import { useNavigate, useParams } from 'react-router-dom';
import { useUsers } from '../../../metodos/userContext';
import { useState, useEffect, useCallback, useRef } from 'react';
import DetallesSolicitudes from './DetallesSolicitudes';
import LoadingWidget from '../../../components/Loadings/LoadingWidget';

const DetallesSolicitudesGuest = ({ publicView = false }) => {
  // Asumiendo que useUsers te da un estado de carga, por ejemplo: loading o initialized
  const { usuario, loadingUsuario } = useUsers(); 
  const { nombreEmpresa, idSolicitud, marca } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    // Debug para ver qué llega realmente
    console.log("Contexto en Guest:", { usuario, loadingUsuario });

    if (!loadingUsuario && usuario && publicView) {
      console.log("Redirigiendo...");
      navigate(`/dashboard/detalle_solicitud/${nombreEmpresa}/${idSolicitud}`, { replace: true });
    }
  }, [usuario, loadingUsuario, publicView, navigate, nombreEmpresa, idSolicitud]);

  // BLOQUEO DE CARGA: Mientras el contexto verifica el token, no mostramos nada 
  // o mostramos un spinner para evitar el "salto" de interfaz
  if (loadingUsuario) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-emerald-600"></div>
        <p className="mt-4 text-gray-500">Verificando sesión...</p>
      </div>
    );
  }

  // Si ya cargó y el usuario está logueado, mostramos el mensaje de redirección
  if (usuario && publicView) 
    return (
      <LoadingWidget
        mensaje={"Redireccionando..."}
      />
    );

  // Solo llegamos aquí si loading === false Y user === null (Invitado real)
  return (
    <div>
        <DetallesSolicitudes 
            publicView={true} 
            marca={marca}
        />
    </div>
  )
}

export default DetallesSolicitudesGuest
